import { defineRule } from 'vee-validate';
import { alpha_num, required, max as maxRule } from '@vee-validate/rules'
import { isAfter, parse, toDate } from "date-fns";

/**
 * Extended functions for vee-validate in one place.
 * Imported in main.js since previous iterations of including the 'extend' in each component's
 * global space was redundant.
 */

export default {
  alphaNum() {
    defineRule('alpha_num', (value) => {
      if (!alpha_num(value)) { 
        return 'Only alphanumeric characters are allowed.';
      }
      return true;
    });
  },

  fieldRequired() {
    defineRule('fieldRequired', (value, params, { field }) => {
      if (!required(value)) { 
        return `${field} is required.`; 
      }
      return true;
    });
  },

  minDate() {
    defineRule('minDate', (value) => {
      // Plain text input field intervention 
      if ((value.match(/\d{2}\/\d{2}\/\d{4}$/g) || []).length === 1) {
        const tmp = value;
        value = `${tmp.substr(6, 4)}-${tmp.substr(0, 2)}-${tmp.substr(3, 2)}`;
      }

      const minDate = toDate(new Date(1751, 11, 31, 23, 59, 59));
      const curDate = parse(value, 'yyyy-MM-dd', new Date());

      // Return the validation result directly from the function
      if (!isAfter(curDate, minDate)) {
        return 'Date must be within the acceptable range.';
      }
      return true;
    });
  },

  minMax() {
    defineRule('minMax', (value, [min, max], { field }) => { 
      const length = value.length; 
      if (length < min || length > max) { 
        return `${field} must have  ${min} or ${max} characters`;
      }
      return true;
    });

  },

  max() {
    defineRule('max', (value, [limit], ctx) => {
      const isValid = maxRule(value, [limit])
      if (!isValid) {
        return `${ctx.field} is limited to ${limit} characters.`
      }
      return true;

    });
  },

  monthBetween() {
    defineRule('monthBetween', (value, [min, max], { field }) => {
      const month = Number(value);
      if (! (min <= month && max >= month) || value.length !== 2) {
        return `${ field } must be between 01 and 12.`;
      }
      return true;
    });
  },

  specialChars() {
    defineRule('specialChars', (value) => {
      const pattern = /^[a-zA-Z0-9!@#$%^&*()_+=[\]{}\u2018\u2019':"\\.>/?`~ ]*$/; 
      if (!pattern.test(value)) { 
        return 'Special characters ";", "<", "|", "," and "-" are not allowed. ' +
        'For hyphenated names please use a space in place of hyphen / dash.';
      }
      return true;
    });
  },

  validYear() {
    defineRule('validYear', (value, [plus], {field}) => { 
      // Business rule ~ "Valid values for YYYY part of the date: Current year plus 20"
      const currentYr = new Date().getFullYear();
      const yearValue = Number(value); 
      if (! (currentYr <= yearValue && (currentYr + plus) >= yearValue)) {
        return `${ field } is not valid.`;
      }   
      return true;
    });
  },
}
